module.exports = __webpack_public_path__ + "img/ticket-bg-y.ef57759.png";